import {FormValidator} from "../form-page/FormValidator";


export class CompactFormPageController
{
    constructor() {
        this.$form = $('[data-controller="CompactFormPageController"]').find('form');

        new FormValidator(this.$form);
    }

}
